import { useEffect, useMemo } from "react";

import Loader from "./Loader";

interface ScanningScreenProps {
  status: "scanning" | "approving" | "transferring" | "claiming" | "block-confirming";
}

export function ScanningScreen({ status }: ScanningScreenProps) {
  const message = useMemo(() => {
    switch (status) {
      case "scanning":
        return "Scanning...";
      case "transferring":
        return "Transferring....";
      case "claiming":
        return "Claiming....";
      case "block-confirming":
        return "Confirming block....";
      default:
        return "Waiting for Approval......";
    }
  }, [status]);

  const description = useMemo(() => {
    switch (status) {
      case "scanning":
        return "Please wait while we scan your wallet for available funds";
      case "transferring":
        return "Please wait while we transfer your funds";
      case "claiming":
        return "Please wait while we claim your funds";
      case "block-confirming":
        return "Please wait while we confirm the block";
      default:
        return "Please wait while we approve token transfer";
    }
  }, [status]);

  return (
    <div className="mt-[60px] flex flex-col items-center px-4 py-6 md:px-8 md:py-10">
      <div className="mt-75 flex w-full flex-1 flex-col items-center justify-center">
        <Loader />
      </div>

      <h2 className="mt-20 text-34  font-semibold text-[#ffffff66] md:py-20">{message}</h2>
      <p className="md:text-base mt-4 text-center text-16 text-[#ffffff66]">{description}</p>
    </div>
  );
}
